import AxiosInstance from "@/components/Axios";

export async function downloadDocuments(projectId: string): Promise<void> {
    try {
        // Set responseType to 'blob' to handle binary file data
        const response = await AxiosInstance.post(`/api/afs/download`, 
            { project_id: projectId },
            { responseType: 'blob' }
        );
        
        // Get filename from content-disposition header if available
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'download';
        
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1].replace(/['"]/g, '');
            }
        }
        
        // If filename doesn't have extension, try to add one based on content type
        if (!filename.includes('.')) {
            const contentType = response.headers['content-type'];
            if (contentType === 'application/pdf') {
                filename += '.pdf';
            } else if (contentType === 'application/zip') {
                filename += '.zip';
            }
        }
        
        // Create a blob URL for the file
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary link element to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        
        // Trigger download and clean up
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        
        return Promise.resolve();
    } catch (error) {
        console.error('Error downloading file:', error);
        return Promise.reject(error);
    }
}